<template>
  <button :class="buttonClass" @click="handleViewDetails">
    {{ t('reservations.viewDetails') }}
  </button>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { defineProps, computed } from 'vue'

  const props = defineProps({
    booking: {
      type: Object,
      required: true,
    },
    buttonStyle: {
      type: String,
      default:
        'button-secondary secondary-normal small flex-grow-1 action-button',
    },
  })

  const { t } = useI18n()
  const emit = defineEmits(['view-details'])

  const handleViewDetails = () => {
    emit('view-details', props.booking)
  }

  const buttonClass = computed(() => props.buttonStyle)
</script>

<style scoped>
  @media (max-width: 768px) {
    .action-button {
      width: 100%; /* Set buttons to full width */
      max-width: 100%; /* Ensure no max width restriction */
    }
  }
</style>
